import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType, RequestOptions } from '@angular/http';
import { Observer } from 'rxjs/Observer';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { HttpClientCustom } from './http.client';
import { Configuration } from './configuration';
import { Router } from '@angular/router';
import 'rxjs';
import { Observable } from 'rxjs';
import * as FileSaver from 'file-saver';
import { ToasterComponent } from 'app/toasterComponent/toasterComponent';

@Injectable()
export class FileService {
    public _userInfo: any;
    public _baseUrl: any;

    constructor(
        public http: HttpClientCustom,
        public _global: Configuration,
        public router: Router,
        public _toaster:ToasterComponent) {
        this._baseUrl = _global.get('EPMS_BASE_URL');
    }

    public download(url, filename, type) {
        let self = this;
        try {
            self.http.get(url, { responseType: 'arraybuffer' }).subscribe(response => {
                var blob = new Blob([response], { type: type });
                FileSaver.saveAs(blob, filename);
            }, (err) => {
                self._toaster.showError('Download Failed');
            });
        } catch (e) {
            console.log('Error in downloadFile::', e);
        }
    }

    public downloadFile(fileDetails) {
        try {
            // loading
            let url = this._baseUrl + 'v1/hub/scorecard/downloadDoc/' + fileDetails.docId;
            this.http.get(url).subscribe(res => {
                let downloadedFileDate = res;
                let FileName = downloadedFileDate.docName + '.' + downloadedFileDate.docType;
                if (downloadedFileDate.docName == null) {
                    this.showToast('errDownload');
                    return;
                }
                let byteCharacters = atob(downloadedFileDate.document);
                let byteNumbers = new Array(byteCharacters.length);
                let byteArray = new Uint8Array(byteNumbers);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteArray[i] = byteCharacters.charCodeAt(i);
                }
                let blob = new Blob([byteArray], { type: downloadedFileDate.docType });
                FileSaver.saveAs(blob, FileName);
            }, (err) => {
                // this.dismissLoading();
                this.showToast('downloadFailed');
            });
        } catch (e) {
            console.log('Error in downloadFile::', e);
        }
    }

    public downloadPdfByScorecard(scorecardId, reviewId) {
        let self = this;
        let url = this._baseUrl +
            'v1/hub/scorecard/downloadReportByScorecard?reportFormat=PDF&scorecardId='
            + scorecardId;
        if (reviewId != null) {
            url += '&reviewId=' + reviewId;
        }
        this.http.get(url).subscribe(
            (result) => {
                setTimeout(window.open(this._baseUrl +
                    'noAuth/downloadScorecardPdf/' + result.text()), 1000);
            }, (err) => {
                console.log(err);
            });
    }

    public downloadPdfBySnapshot(snapshotId, reviewId) {
        let self = this;
        let url = this._baseUrl + 'v1/hub/scorecard/downloadReportBySnapshot?'
            + 'reportFormat=PDF&snapshotId=' + snapshotId;
        if (reviewId != null) {
            url += '&reviewId=' + reviewId;
        }
        this.http.get(url).subscribe((result) => {
            setTimeout(window.open(this._baseUrl
                + 'noAuth/downloadScorecardPdf/' + result.text()), 1000);
        }, (err) => {
            console.log(err);
        });
    }
    showToast(err) {
        alert('msg');
    }

    public downloadScorecardSummary(entitiName, programId, format) {
        let self = this;
        let url = self._baseUrl + 'v1/webAdmin/performance/getSummaryBasedScorecard/' + entitiName + "/" + programId + "/" + format;
        return self.http.getBlob(url).subscribe(
            (result: HttpResponse<Blob>) => {
                if (result.status == 204) {
                    this._toaster.showError("No Records found to generate report");
                } else {
                    const blob = result.body;
                    const filename = result.headers.get("content-disposition").split("=")[1];
                    FileSaver.saveAs(blob, filename);
                }
            }
        ), (err) => {
            console.log("TTTTTTTTTTTTTTTTtttt");
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/fileService.ts